import React from 'react';
import Paginations from '../../common/paginations';
import { Link } from 'react-router-dom/cjs/react-router-dom.min';
import constant from '../../../constant';

const List = ({ data, limit, handlePageChange }) => {
    const { page, total, projects, groups } = data;

    // Extract dynamic categories from first ship
    const categories =
        projects?.[0]?.ships?.[0]?.categoryStats?.map(c => ({
            id: c.CATEGORY_ID,
            name: c.CATEGORY_NAME,
        })) || [];

    const renderRow = (item) => {
        if (!item) return null;

        const ships = Array.isArray(item.ships) ? item.ships : [];

        return (
            <div key={item.PROJECT_ID} className="ncr-table-wrapper">
                <table className="plan-approval-table ncr-project-table">
                    <thead>
                        <tr>
                            <th className="w250 comName" rowSpan={2} style={{ zIndex: '50' }}>
                                {item.PROJECT_CODE} - {item.PROJECT_NAME}
                            </th>

                        {categories.map((cat) => (
                            <th key={cat.id} colSpan={2}>
                                {cat.name}
                            </th>
                        ))}

                        <th colSpan={3}>Total</th>
                    </tr>

                    <tr>
                        {categories.map((cat) => (
                            <React.Fragment key={cat.id}>
                                <th>Open</th>
                                <th>Close</th>
                            </React.Fragment>
                        ))}
                        <th>Draft</th>
                        <th>Open</th>
                        <th>Close</th>
                    </tr>
                </thead>

                <tbody>
                    {ships.length > 0 ? (
                        ships.map((ship) => {
                            const categoryStats = Array.isArray(ship?.categoryStats) ? ship.categoryStats : [];
                            const totalOpen = categoryStats.reduce(
                                (sum, c) => sum + Number(c.OPEN_COUNT || 0),
                                0
                            );

                            const totalClose = categoryStats.reduce(
                                (sum, c) => sum + Number(c.CLOSE_COUNT || 0),
                                0
                            );

                            const totalDraft = categoryStats.reduce(
                                (sum, c) => (c.STATUS === 'Draft' ? sum + 1 : sum),
                                0
                            );

                            return (
                                <tr key={ship.SHIP_ID}>
                                    <td className="ship-cell">
                                        <p className="s1">
                                            <Link
                                                to={{
                                                    pathname:
                                                        constant.Authedcomponent.ncrList.url,
                                                    state: {
                                                        shipId: ship.SHIP_ID,
                                                        projectId: ship.PROJECT_ID,
                                                        shipName: `${ship.HULL_NUMBER} - ${ship.SHIP_NAME}`,
                                                    },
                                                }}
                                            >
                                                {ship.HULL_NUMBER} - {ship.SHIP_NAME}
                                            </Link>
                                        </p>
                                    </td>

                                    {categories.map((cat) => {
                                        const stat = categoryStats.find(
                                            (c) => c.CATEGORY_ID === cat.id
                                        );

                                        return (
                                            <React.Fragment key={cat.id}>
                                                <td>{stat?.OPEN_COUNT || 0}</td>
                                                <td>{stat?.CLOSE_COUNT || 0}</td>
                                            </React.Fragment>
                                        );
                                    })}

                                    <td>{totalDraft}</td>
                                    <td>{totalOpen}</td>
                                    <td>{totalClose}</td>
                                </tr>
                            );
                        })
                    ) : (
                        <tr>
                            <td colSpan="50" className="text-center">
                                No Record Found
                            </td>
                        </tr>
                    )}
                </tbody>
                </table>
            </div>
        );
    };

    return (
        <>
            {groups
                ? Object.entries(groups).map(([groupName, groupProjects]) => (
                    <React.Fragment key={groupName}>
                        <div className="company-name-hul">
                            <h4>{groupName}</h4>
                        </div>
                        {(Array.isArray(groupProjects) ? groupProjects : []).map(renderRow)}
                    </React.Fragment>
                ))
                : projects?.length > 0
                    ? projects.map(renderRow)
                    : null}

            <Paginations
                limit={limit}
                totalCount={total}
                range={5}
                currentPage={page}
                onPageChange={handlePageChange}
            />
        </>
    );
};

export default List;
